<template>
  <div class="socials">
    <div class="socials__title">{{ title || $tFooter('Social media channels') }}</div>
    <div class="socials__list">
      <a v-for="item in list"
         :key="item.id"
         :href="item.url"
         :target="item.target"
         class="socials__link">
        <BaseSvg v-if="item.title.toLowerCase()  === 'facebook'"
                 name="ico-facebook"
                 width="0.8rem"
                 height="1.6rem"
        />
        <BaseSvg v-else-if="item.title.toLowerCase()  === 'twitter'"
                 name="ico-twitter"
                 width="1.5rem"
                 height="1.2rem"
        />
        <BaseSvg v-else-if="item.title.toLowerCase()  === 'youtube'"
                 name="ico-youtube"
                 width="1.7rem"
                 height="1.2rem"
        />
        <BaseSvg v-else-if="item.title.toLowerCase()  === 'linkedin'"
                 name="ico-linkedin"
                 width="1.7rem"
                 height="1.5rem"
        />
        <BaseSvg v-else-if="item.title.toLowerCase()  === 'viber'"
                 name="ico-viber"
                 width="1.9rem"
                 height="2rem"
                 style="position: relative; top: 0.1rem"
        />
        <span v-else>{{ item.title }}</span>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      list: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style lang="less">

</style>
